import ScannerLink from './ScannerLink';

export default ScannerLink;
